export const RESOLVED_DATE_TEST_ID = 'resolved-date.ui.read.meta-date';
